import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { colors } from "../../theme";

interface Props {
  password: string;
  handleChange: (password: string) => void;
  error: boolean;
}

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  currenPassword: {
    margin: "0 auto",
    width: "100%",
  },
  textField: {
    margin: "0 auto",
    width: "100%",
  },
  error: {
    color: colors.ERROR,
  },
}));

export default function CurrentPassword({
  password,
  handleChange,
  error,
}: Props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const changePassword = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>
  ) => {
    handleChange(event.target.value as string);
  };

  return (
    <>
      <div className={classes.currenPassword}>
        <div style={{ marginBottom: "15px" }}>
          <Typography>{t("currentpassword.entercurrentpassword")}</Typography>
        </div>
        <FormControl className={classes.textField} variant="outlined">
          <InputLabel htmlFor="currentPassword">
            <span className={error ? classes.error : undefined}>
              {t("currentpassword.currentpassword")}
            </span>
          </InputLabel>
          <OutlinedInput
            id="currentPassword"
            name="currentPassword"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            required
            error={error ? error : false}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={toggleShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            value={password}
            labelWidth={138}
            onChange={changePassword}
          />
          {error && (
            <FormHelperText className={classes.error}>
              {t("currentpassword.password_required")}
            </FormHelperText>
          )}
        </FormControl>
      </div>
    </>
  );
}
